import ExternalRequestAccessTooltip from './ExternalRequestAccessTooltip.container';

export default ExternalRequestAccessTooltip;
